import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { StyledGrid, StyledRow, StyledCol, StyledSpanPax } from "../styled";

const messages = defineMessages({
  paxPax: {
    id: "quotation.pax.pax",
    defaultMessage: "PAX",
  },
  paxAdults: {
    id: "quotation.pax.adults",
    defaultMessage: "adultos",
  },
  paxJuniors: {
    id: "quotation.pax.juniors",
    defaultMessage: "juniors",
  },
  paxChildren: {
    id: "quotation.pax.children",
    defaultMessage: "niños",
  },
  paxBabies: {
    id: "quotation.pax.babies",
    defaultMessage: "bebes",
  },
  paxRoom: {
    id: "quotation.pax.room",
    defaultMessage: "habs.",
  },
});

const getValuesPax = (tab: any, intl: any) => {
  let adults: number = 0;
  let teenager: number = 0;
  let childrens: number = 0;
  let babies: number = 0;
  let uds: number = 0;
  tab.accommodations.forEach((element: any) => {
    adults += Number(element?.adults?.value) || 0;
    teenager += Number(element?.juniors?.value) || 0;
    childrens += Number(element?.childrens?.value) || 0;
    babies += Number(element?.babies?.value) || 0;
    uds += element?.rooms?.value || 0;
  });
  return `${intl.formatMessage(messages.paxPax)} (${
    adults + childrens + babies
  }): ${adults} ${intl.formatMessage(messages.paxAdults)}, ${teenager} ${intl.formatMessage(
    messages.paxJuniors
  )}, ${childrens} ${intl.formatMessage(messages.paxChildren)}, ${babies} ${intl.formatMessage(
    messages.paxBabies
  )}, (${uds} ${intl.formatMessage(messages.paxRoom)})`;
};

export const SectionPax = ({ tab }: any) => {
  const intl = useIntl();
  return (
    <StyledGrid>
      <StyledRow>
        <StyledCol xs={12}>
          <StyledSpanPax> {getValuesPax(tab, intl)}</StyledSpanPax>
        </StyledCol>
      </StyledRow>
    </StyledGrid>
  );
};
